export default "__VITE_ASSET__BE6l0JZQ__"